export default "__VITE_ASSET__BvsMPpBp__"